import { FeedbackRequest, FeedbackResponse, Message } from "./Types";
import ApiService from "./ApiService";

export const getMessages = async (tenantId: string, threadId: string, signal?: AbortSignal): Promise<Message[]> => {
    const response = await ApiService.get<Message[]>({ url: `/tenants/${tenantId}/threads/${threadId}/messages`, signal });
    if (import.meta.env.DEV) console.log('Fetched messages for thread', threadId);
    return response;
}

export const sendMessage = async (tenantId: string, threadId: string, content: string, signal?: AbortSignal): Promise<void> => {
    await ApiService.post({ url: `tenants/${tenantId}/threads/${threadId}/run`, data: { content }, signal });
}

export const startNewConversation = async (tenantId: string, content: string, signal?: AbortSignal): Promise<{ threadId: string }> => {
    const response = await ApiService.post<{ threadId: string }>({ url: `/tenants/${tenantId}/threads/run`, data: { content }, signal });
    return response;
}

export const streamMessage = async (
    tenantId: string,
    threadId: string,
    content: string,
    onMessage: (msg: string) => void,
    onError: (err: any) => void
): Promise<void> => {
    await ApiService.postStream( {
        url: `tenants/${tenantId}/threads/${threadId}/messages`,
        data: { content },
        onMessage,
        onError
    });
};

export const submitFeedback = async (
    tenantId: string,
    threadId: string,
    messageId: string,
    body: FeedbackRequest,
    signal?: AbortSignal
): Promise<FeedbackResponse> => {
    return ApiService.post<FeedbackResponse>({
        url: `tenants/${tenantId}/threads/${threadId}/messages/${messageId}/feedback`,
        data: body,
        signal,
    });
};